import { mapState, mapGetters } from 'vuex';
import coupon from '@mixins/officialTopupNew/coupon';
import {
  SET_HAS_LOAD_PAYTYPE,
  UPDATE_LOADING,
  UPDATE_HAS_SELECT_PRODUCT,
  UPDATE_PAY_SUBMIT_PAGE_URL
} from '@store/officialTopupNew';
import {
  CLEAR_CASH_PARAMS,
  handleBeforeUnload
} from '@store/officialTopupNew/cash';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV35';

export default {
  mixins: [coupon],
  computed: {
    ...mapState({
      hasLoadPaytype: state => state.hasLoadPaytype,
      canUseCart: state => state.cart.canUseCart,
      cartList: state => state.cart.cartList,
      gameId: state => state.gameId
    }),
    ...mapGetters(['cartTotalQuantity', 'isCart']),
    hasValidGameCoupon() {
      return this.gameCouponEnableList?.length > 0;
    },
    showUseCartGuideTip() {
      if (
        this.hasLoadPaytype &&
        this.canUseCart &&
        this.hasValidGameCoupon &&
        (!this.isCart || (this.isCart && this.cartTotalQuantity === 1))
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    handleUseCartGuide() {
      clickButton({
        btnName: 'go_addon_product'
      });
      this.reSelectProduct();
    },
    handleReSelectProduct() {
      clickButton({
        btnName: 'back_select_product',
        locationKey: locationType.selectProduct
      });
      this.reSelectProduct();
    },
    reSelectProduct() {
      this.reSelectPayType();
      this.$store.commit(UPDATE_PAY_SUBMIT_PAGE_URL, '');
      this.$store.commit(CLEAR_CASH_PARAMS);
      this.$store.commit(SET_HAS_LOAD_PAYTYPE, false);
      this.$store.commit(UPDATE_HAS_SELECT_PRODUCT, false);
      this.$store.commit(UPDATE_LOADING, false);
    },
    reSelectPayType() {
      this.$store.commit(UPDATE_PAY_SUBMIT_PAGE_URL, '');
      this.$store.commit(CLEAR_CASH_PARAMS);
      handleBeforeUnload();
    }
  }
};
